import React, { useEffect, useState } from 'react'
import { withApollo, Mutation } from 'react-apollo'
import { Link } from 'react-router-dom'
import omit from 'lodash/omit'
import get from 'lodash/get'
import {
  Container,
  Segment,
  Button,
  Header,
  Form,
  Divider,
} from 'semantic-ui-react'
import Select from 'react-select'

import { FIND_POLL_QUERY } from 'graphql/queries'
import { UPDATE_POLL_MUTATION, CREATE_POLL_MUTATION } from 'graphql/mutations'
import { POLLS_QUERY } from '../List'

const ANSWER = {
  answer: '',
  result: '',
  isCorrect: false,
  active: true,
}
const initialAnswerState = [ANSWER, ANSWER]
const initialState = {
  id: '',
  question: '',
  explanation: '',
  url: '',
  urlText: '',
  answers: initialAnswerState,
}

export const POLL_TYPE_OPTIONS = [
  { value: 'poll', label: 'Poll - no correct answer' },
  // { value: 'multiple_answer', label: 'Poll - multiple answers' },
  { value: 'correct_answer', label: 'Quiz - correct answer' },
  // { value: 'survey', label: 'Survey - free response' },
]

const cleanNullStringFields = obj => {
  for (let field in obj) {
    if (obj[field] === null) {
      obj[field] = ''
    }
  }
  return obj
}

const PollsNew = props => {
  const [pollType, setPollType] = useState(POLL_TYPE_OPTIONS[0])
  const [poll, setPoll] = useState(initialState)
  const pollId = get(props, 'match.params.pollId', '')
  useEffect(
    () => {
      if (pollId) {
        props.client
          .query({
            query: FIND_POLL_QUERY,
            variables: { id: pollId },
          })
          .then(res => {
            const poll = omit(res.data.poll, [
              '__typename',
              'created',
              'updated',
            ])
            let initialPoll = cleanNullStringFields(poll)
            initialPoll.answers = initialPoll.answers.map(answer => {
              return cleanNullStringFields(omit(answer, '__typename'))
            })

            if (initialPoll.answers.length === 1) {
              setPollType(POLL_TYPE_OPTIONS[3])
            } else if (initialPoll.answers.some(answer => answer.isCorrect)) {
              setPollType(POLL_TYPE_OPTIONS[2])
            }
            setPoll(initialPoll)
          })
      }
    },
    [pollId],
  )

  return (
    <Container style={{ marginBottom: 64 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Header as="h1" content="New Poll/Quiz" />
        <div style={{ display: 'flex' }}>
          <Mutation
            mutation={poll.id ? UPDATE_POLL_MUTATION : CREATE_POLL_MUTATION}
            refetchQueries={[
              { query: POLLS_QUERY, variables: { limit: 20, offset: 0 } },
            ]}
          >
            {savePoll => {
              return (
                <Button
                  primary
                  onClick={() => {
                    const { id, ...input } = omit(poll, ['__typename'])
                    const variables = id ? { id, input } : { input }
                    savePoll({ variables })
                      .then(() => props.history.push('/polls'))
                      .then(() => {
                        // We need to clear existing cache for current pool in order to make updates visible at client
                        Object.keys(props.client.cache.data.data).map(
                          key =>
                            props.client.cache.data.data[key].id === id &&
                            props.client.cache.data.delete(key),
                        )
                      })
                  }}
                >
                  Save
                </Button>
              )
            }}
          </Mutation>
          <Link to="/polls">
            <Button>Back</Button>
          </Link>
        </div>
      </div>

      <Form>
        <Select
          options={POLL_TYPE_OPTIONS}
          value={pollType}
          onChange={option => setPollType(option)}
        />

        <Form.Input
          label="Question"
          id="question"
          value={poll.question}
          onChange={event => setPoll({ ...poll, question: event.target.value })}
        />

        <Segment>
          <div style={{ marginBottom: 12 }}>
            {poll.answers.map((a, i) => {
              return (
                <React.Fragment key={i}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ flex: 1, marginRight: 8 }}>
                      <Form.Input
                        label={`Answer ${i}`}
                        id={`answer-${i}`}
                        value={a.answer}
                        onChange={event => {
                          const answers = poll.answers.map((an, j) => {
                            if (i === j) {
                              return { ...an, answer: event.target.value }
                            }
                            return an
                          })
                          setPoll({ ...poll, answers })
                        }}
                      />
                      <Form.Input
                        label={`Result ${i}`}
                        id={`result-${i}`}
                        value={a.result}
                        onChange={event => {
                          const answers = poll.answers.map((an, j) => {
                            if (i === j) {
                              return { ...an, result: event.target.value }
                            }
                            return an
                          })
                          setPoll({ ...poll, answers })
                        }}
                      />
                    </div>
                    <div>
                      {poll.answers.length > 2 && (
                        <Button
                          color="red"
                          onClick={() => {
                            const answers = poll.answers.filter(
                              (_, j) => j !== i,
                            )
                            setPoll({ ...poll, answers })
                          }}
                        >
                          Delete
                        </Button>
                      )}
                      {pollType.value === 'correct_answer' && (
                        <Form.Input
                          label="Correct"
                          type="radio"
                          id={`isCorrect-${i}`}
                          name="isCorrect"
                          value={a.isCorrect}
                          onChange={event => {
                            const answers = poll.answers.map((an, j) => {
                              return {
                                ...an,
                                isCorrect: i === j,
                              }
                            })
                            setPoll({ ...poll, answers })
                          }}
                        />
                      )}
                    </div>
                  </div>
                  {i !== poll.answers.length - 1 && <Divider />}
                </React.Fragment>
              )
            })}
          </div>

          {poll.answers.length < 8 && (
            <Button
              primary
              onClick={() =>
                setPoll({ ...poll, answers: poll.answers.concat(ANSWER) })
              }
            >
              Add Answer
            </Button>
          )}
        </Segment>

        <Form.Input
          label="Explanation"
          id="explanation"
          value={poll.explanation}
          onChange={event =>
            setPoll({ ...poll, explanation: event.target.value })
          }
        />
        <Form.Input
          label="URL"
          id="url"
          value={poll.url}
          onChange={event => setPoll({ ...poll, url: event.target.value })}
        />
        <Form.Input
          label="URL Text"
          id="urlText"
          value={poll.urlText}
          onChange={event => setPoll({ ...poll, urlText: event.target.value })}
        />
      </Form>
    </Container>
  )
}

export default withApollo(PollsNew)
